import {
  KEYCLOAK_AUTH_COOKIE_NAME,
  resolveBooleanFlag,
  resolveOidcAuthority,
  resolveOidcScope,
} from '@metaforcelabs/docgen-identity-web'


export const config = {
  apiBaseUrl: window._env_.REACT_APP_API_BASE_URL,
  tokenStorageKey: '@MetaForce:userToken',
  identityBaseUrl: window._env_.REACT_APP_IDENTITY_BASE_URL,
  centerpointBaseUrl: window._env_.REACT_APP_CENTERPOINT_BASE_URL,
  centerpointUiBaseUrl: window._env_.REACT_APP_CENTERPOINT_UI_BASE_URL,
  docsUrl: window._env_.REACT_APP_DOCUMENTATION_URL,
}

// The cookie name has to byte-match AuthProxy's KeycloakProxyCookieMiddleware.CookieName in
// CenterPoint - a different service in a different language, with no test spanning both - which
// is why it is a named export rather than a string each app types for itself (MET2-457). The
// realm name and the offline_access rule come from the same package for the same reason
// (MET2-468): they are properties of the realm and of whichever provider answers, not of this
// app. What stays here is this app's own scope list and client id.
//
// This is the React app only. The WebApi in this repository still carries its own copy of the
// backend dual-auth handler, and has to: DocGen.Identity targets net10.0 and this API is on
// net6.0, so NuGet has no compatible asset. That is recorded where it applies, in
// Infrastructure/Authentication/SplitScopeClaimsTransformation.cs.
const useKeycloak = resolveBooleanFlag(KEYCLOAK_AUTH_COOKIE_NAME, window._env_.REACT_APP_USE_KEYCLOAK)
const authority = resolveOidcAuthority(window._env_.REACT_APP_AUTHORITY, useKeycloak)
const scope = resolveOidcScope('openid profile email api.internal', useKeycloak)

export const oidcConfig = {
  client_id: 'textlibrary_web',
  redirect_uri: window._env_.REACT_APP_REDIRECT_URI,
  response_type: 'code',
  post_logout_redirect_uri: window._env_.REACT_APP_POST_LOGOUT_REDIRECT_URI,
  scope,
  authority,
  silent_redirect_uri: window._env_.REACT_APP_SILENT_REDIRECT_URI,
  automaticSilentRenew: true,
  loadUserInfo: true,
};